(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-bits-wallpaper"] && !Shopify.designMode) return;
  try {
    
  const sectionId = document.querySelector('.best-bits').id;
	ScrollTrigger.matchMedia({
	// desktop
	"(min-width: 1024px)": function() {

		// Photo Change Desktop
		gsap.to(`${sectionId} #threecol`, {
			scrollTrigger: {
				trigger: `${sectionId} #threecol`,
				start: "center 90%",
				endTrigger:"html",
				end:"bottom top",
				id: "Desktop Photo Change Start",
				markers: false,
				toggleClass: {targets: ".onestart, .twostart, .threestart", className: "hide"}
			}
		});

		gsap.to(`${sectionId} #threecol`, {
			scrollTrigger: {
				trigger: `${sectionId} #threecol`,
				start: "center 90%",
				endTrigger:"html",
				end:"bottom top",
				id: "Desktop Photo Change End",
				markers: false,
				toggleClass: {targets: ".oneend, .twoend, .threeend", className: "show"}
			}
		});
	}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["best-bits"] && !Shopify.designMode) return;
  try {
    
  const sectionId = document.querySelector('.best-bits').id;
	ScrollTrigger.matchMedia({
	// desktop
	"(min-width: 1024px)": function() {

		// Photo Change Desktop
		gsap.to(`${sectionId} #threecol`, {
			scrollTrigger: {
				trigger: `${sectionId} #threecol`,
				start: "center 90%",
				endTrigger:"html",
				end:"bottom top",
				id: "Desktop Photo Change Start",
				markers: false,
				toggleClass: {targets: ".onestart, .twostart, .threestart", className: "hide"}
			}
		});

		gsap.to(`${sectionId} #threecol`, {
			scrollTrigger: {
				trigger: `${sectionId} #threecol`,
				start: "center 90%",
				endTrigger:"html",
				end:"bottom top",
				id: "Desktop Photo Change End",
				markers: false,
				toggleClass: {targets: ".oneend, .twoend, .threeend", className: "show"}
			}
		});
	}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["categories-blocks"] && !Shopify.designMode) return;
  try {
    
  const sectionId = document.querySelector('.categories-block').id;
  ScrollTrigger.matchMedia({
  // desktop
  "(min-width: 1024px)": function() {

    // Photo Change Desktop
    gsap.to(sectionId, {
      scrollTrigger: {
        trigger: sectionId,
        start: "center 90%",
        endTrigger:"html",
        end:"bottom top",
        id: "Desktop Photo Change Start",
        markers: false,
        toggleClass: {targets: ".onestart, .twostart, .threestart", className: "hide"},
        preventOverlaps: true,
        fastScrollEnd: true
      }
    });

    gsap.to(sectionId, {
      scrollTrigger: {
        trigger: sectionId,
        start: "center 90%",
        endTrigger:"html",
        end:"bottom top",
        id: "Desktop Photo Change End",
        markers: false,
        toggleClass: {targets: ".oneend, .twoend, .threeend", className: "show"},
        preventOverlaps: true,
        fastScrollEnd: true
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["explore-places"] && !Shopify.designMode) return;
  try {
    
  tns({
      container: '.js-explore-places',
      items: 1.5,
      mouseDrag: true,
      controls: false,
      nav: false,
      preventScrollOnTouch: false,
      responsive: {
          400: {
              items: 1.5
          },
          640: {
              items: 1.5
          },
          700: {
              items: 2.5
          },
          1024: {
              items: 3.5
          },
          1280: {
              items: 4
          }
      }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-in"] && !Shopify.designMode) return;
  try {
    
    tns({
      container: '.js-featured-in',
      items: 1,
      mouseDrag: true,
      controls: false,
      nav: false,
	  	preventScrollOnTouch:false,
      responsive: {
        640: {
          items: 2
        },
        700: {
          items: 3
        },
        1024: {
          items: 4
        }
      }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
    const Header = document.querySelector('#main-header');

    const setMegaMenuActive = (id) => {
      const megaMenuItems = document.querySelectorAll('[id*="megamenu-item--"]');
      megaMenuItems.forEach(item => {
        item.style.display = 'none';
      });

      const currentMegaMenuItem = document.querySelector(id);
      currentMegaMenuItem.style.display = 'flex';

      Header.classList.add('megamenu-open');
    }

    const initHeaderFunc = () => {
      const megaMenu = document.querySelector('#megamenu-content');
      const megaMenuItems = document.querySelectorAll('#main-menu li a');
      const negativeSpace = (window.innerWidth - megaMenu.offsetWidth) / 2;
      const menuLeftPosition = window.theme.GetOffset()('#main-menu').left;

      megaMenu.style.marginLeft = (menuLeftPosition - negativeSpace) + 'px';
      megaMenuItems.forEach(item => {
        item.addEventListener('mouseenter', (e) => {
          if (item.dataset.megamenuItem !== undefined) {
            setMegaMenuActive(e.target.dataset.megamenuItem);
          } else {
            Header.classList.remove('megamenu-open');
          }
        });

        item.addEventListener('click', (e) => {
          const { name, position } = e.target.dataset;
          //window.trackPromotion(name, e.target.href, position);
        })
      });

      Header.addEventListener('mouseleave', (e) => {
        if (!Header.classList.contains('megamenu-search')) {
          Header.classList.remove('megamenu-open');
        }
      });

      // onScroll();
    };

    const headerInterval = () => {
      const headerRetry = setInterval(() => {
        if (window.theme) {
          clearInterval(headerRetry);
          initHeaderFunc();
        }
      }, 250);
    }

    if (document.readyState !== 'loading') {
      headerInterval();
    } else {
      window.addEventListener('load', function () {
        headerInterval();
      });
    }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by"] && !Shopify.designMode) return;
  try {
    
  const shopBy = tns({
    container: '.js-shop',
    items: 1.5,
    mouseDrag: true,
    controls: false,
    nav: false,
    swipeAngle: 25,
    preventScrollOnTouch: "auto",
    loop: true,
    responsive: {
      400: {
        items: 1.5
      },
      1024: {
        items: 2.5
      },
      1280: {
        items: 3
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
